
import { message } from 'antd';
import { find } from 'lodash';
import { addAndUpdateVendorDieCasting, getVendorDieCasting, deleteVendorDieCasting } from '../services/supplierApi';

function init() {
  return {
    data: [],
    record: {},
    visiable: false
  };
}

export default {
  namespace: 'dieCastingAbility',
  state: init(),
  effects: {
    *getData(_, { call, put }) {
      const res = yield call(getVendorDieCasting);
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            data: {
              data: res.data
            }
          }
        });
      } else {
        res.msg && message.error(res.msg);
      }
    },
    *showEditModal({ payload: { data: { serialNumberD } } }, { put, select }) {
      const data = yield select(state => state.dieCastingAbility.data);
      const record = find(data, { serialNumberD });
      yield put({
        type: 'updateState',
        payload: {
          data: {
            record,
            visible: true
          }
        }
      });
    },
    *addAndUpdate({ payload: { data } }, { call, put }) {
      const result = yield call(addAndUpdateVendorDieCasting, data);
      if (result.success) {
        message.success('操作成功');
        yield put({
          type: 'updateState',
          payload: {
            data: {
              visible: false
            }
          }
        });
        yield put({
          type: 'getData'
        });
      } else {
        result.msg && message.error(result.msg);
      }
    },
    *delete({ payload: { serialNumberD } }, { call, put }) {
      const result = yield call(deleteVendorDieCasting, { serialNumber: serialNumberD });
      if (result.success) {
        message.success('操作成功');
        yield put({
          type: 'getData'
        });
      } else {
        result.msg && message.error(result.msg);
      }
    },
  },
  reducers: {
    updateState(state, { payload: { data } }) {
      return {
        ...state,
        ...data
      };
    },
    clear() {
      return init();
    }
  }
};

